import { request } from '@tencent/ppd-base-libs';
import { amount } from '@tencent/wphk-base-utils';

export interface CouponItem {
  /** 活动名称 */
  activityName: string;
  /** 优惠券名称 */
  couponName: string;
  /** 生效时间 */
  validTime: string;
  /** 过期时间 */
  expireTime: string;
  /** 优惠券Logo */
  merLogoUrl: string;
  /** 是否渠道券 */
  isChannelCoupon: boolean;
  /** 优惠券user coupon id */
  userCouponId: string;
  /** 是否即将过期 过期时间T-3 */
  isExpireNotified: boolean;
  /** 是否为折扣券 */
  isDiscountCoupon: boolean;
  /** 优惠券金额 或 优惠折扣 */
  discount: string;
  /** 优惠折扣英文 */
  discountEn: string;
  /** 原始优惠券金额或者优惠折扣 */
  originDiscount: string
}

export enum CouponType {
  AMOUNT_COUPON = 1,
  DISCOUNT_COUPON = 2,
}

export const replaceTimeFormat = (date: string): string => (date || '').replace(/-/g, '/');
export const formatIsExpireNotified = (expireFlag: string): boolean => +expireFlag === 1;
export const formatIsChannelCoupon = (payChannel: string): boolean => +payChannel === 2;
export const formatIsDiscountCoupon = (couponType: string): boolean => +couponType === CouponType.DISCOUNT_COUPON;
export const formatDiscount = (discount = '', clearZero = true): string => {
  if (clearZero) {
    return amount.fen2Yuan(discount).replace('.00', '')
      .replace(/\.([1-9])0$/, '.$1');
  }
  return amount.fen2Yuan(discount);
};

export async function getCouponList({ offset, useableFlag, limit }): Promise<CouponItem[]> {
  const res = await request.post('/app/promotion/prom_qry_usercoupon_list.cgi', {
    useable_flag: useableFlag,
    offset,
    limit,
  });
  if (res?.couponList) {
    return res.couponList.map(coupon => ({
      activityName: coupon.activity_name,
      /** 优惠券名称 */
      couponName: coupon.coupon_name,
      /** 生效时间 */
      validTime: replaceTimeFormat(coupon.valid_time),
      /** 过期时间 */
      expireTime: replaceTimeFormat(coupon.expire_time),
      /** 优惠券Logo */
      merLogoUrl: coupon.mer_logo_url,
      /** 是否渠道券 */
      isChannelCoupon: formatIsChannelCoupon(coupon.pay_chn),
      /** 优惠券user coupon id */
      userCouponId: coupon.user_coupon_id,
      /** 是否即将过期 过期时间T-3 */
      isExpireNotified: formatIsExpireNotified(coupon.being_expire_flag),
      /** 是否为折扣券 */
      isDiscountCoupon: formatIsDiscountCoupon(coupon.coupon_type),
      /** 优惠券金额 或 优惠折扣 */
      discount: formatDiscount(coupon.discount),
      /** 优惠折扣英文 */
      discountEn: coupon.discount,
      /** 原始优惠券金额或者优惠折扣 */
      originDiscount: coupon.discount,
    }));
  }
  return [];
}
